function Url()
{
    // return 'https://promotervit.herokuapp.com';
    return 'https://phoguj6tj6.execute-api.us-east-1.amazonaws.com/prod';
}

export {Url};